module.exports = __webpack_public_path__ + "static/media/2_en.92611ead.png";